import type { VoidFunctionComponent } from 'react';

import HeaderContentFailing from './HeaderContentFailing';
import HeaderContentPassing from './HeaderContentPassing';
import HeaderStatsList from './HeaderStatsList';
import ScanSummaryBadge from './ScanSummaryBadge';

import styles from './ProjectPreview.module.less';

type Props = {
  baseURL: string;
  deepestLevel: number;
  issueCount: number;
  dependencyCount: number;
  licenseCount: number;
  todoCount: number;
};

/**
 * Header section of the project preview showing scan status and stats
 */
const ScanSummaryHeader: VoidFunctionComponent<Props> = ({
  baseURL,
  deepestLevel,
  issueCount,
  dependencyCount,
  licenseCount,
  todoCount,
}) => (
  <div className={`panel panel-flat panel-responsive padded animated fadeInUp ${styles.headerPanel}`}>
    <ScanSummaryBadge />
    <div className="animated fadeInLeft quick row">
      <div className="col-md-6">
        {issueCount > 0 ? (
          <HeaderContentFailing deepestLevel={deepestLevel} issueCount={issueCount} />
        ) : (
          <HeaderContentPassing deepestLevel={deepestLevel} />
        )}
      </div>
      <div className="col-md-6 text-right">
        <HeaderStatsList
          baseURL={baseURL}
          dependencyCount={dependencyCount}
          licenseCount={licenseCount}
          todoCount={todoCount}
        />
      </div>
    </div>
  </div>
);

export default ScanSummaryHeader;
